export * from '@sayyoo/services-ec';



//////////////////
// WEBPACK FOOTER
// ./~/@sayyoo/services-http-apis/lib/ec.js
// module id = ScYI
// module chunks = 256